// extracted by mini-css-extract-plugin
export default {"stepTextInput__label":"StepTextInput_stepTextInput__label__H+ZCd","stepTextInput__item":"StepTextInput_stepTextInput__item__7Gm26"};